import React from 'react'
import Search from './components/Search'

const App: React.FC = () => {
  return (
    <div>
      <Search />
    </div>
  )
}

export default App
